import React from "react";
import { useState } from "react";
import * as ManagedServiceStore from "../ManagedServiceStore";
import { ConfigFormField } from "../../organizations/OrganizationManagedServices";
import SquareButton from "../../general/SquareButton";
import { Button, Modal, ModalBody } from "reactstrap";
import { set } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ScadsysManagedService = ({ organizationId, onDone }) => {
    const setConfig = (key) => (e) => {
        const newConfig = { ...newManagedService.configuration };
        set(newConfig, key, e.target.value);
        setNewManagedService({ ...newManagedService, configuration: newConfig });
    };

    const BoundConfigFormField = (key, name) => {
        return ConfigFormField(key, name, newManagedService.configuration, setConfig);
    };

    const [showModal, setShowModal] = useState(false);
    const [errors, setErrors] = useState([] as any[]);

    const [newManagedService, setNewManagedService] = useState({ type: 2, organizationId: organizationId, configuration: { webServiceUrl: "", webServiceReference: "", onlineSchoolID: "" } } as any);

    const start = () => {
        setShowModal(true);
        setNewManagedService({ type: 2, organizationId: organizationId, configuration: { webServiceUrl: "", webServiceReference: "", onlineSchoolID: "" } });
    };

    const complete = () => {
        ManagedServiceStore.CreateManagedService(organizationId, newManagedService)
            .then((response) => {
                setErrors([]);
                setShowModal(false);
                onDone();
            })
            .catch((error) => {
                if (error.response.data.errors && error.response.data.errors.length > 0) {
                    setErrors(error.response.data.errors);
                }
            });
    };

    return (
        <>
            <>
                <SquareButton className="col" onClick={start}>
                    Scadsys
                    <br />
                    {/* @ts-ignore */}
                    <FontAwesomeIcon icon={["fad", "circle-plus"]} size="lg" className="text-primary"></FontAwesomeIcon>
                </SquareButton>
            </>
            <Modal isOpen={showModal} toggle={() => setShowModal(!showModal)} centered={true}>
                <ModalBody>
                    <h3>New Scadsys Managed Service</h3>
                    {BoundConfigFormField("onlineSchoolID", "Online School ID")}
                    {BoundConfigFormField("webServiceUrl", "Web Service URL")}
                    {BoundConfigFormField("webServiceReference", "Web Service Reference")}

                    <Button color="primary" onClick={complete}>
                        Create
                    </Button>
                    {errors.length > 0 && (
                        <div className="text-danger">
                            {errors.map((error, i) => (
                                <div key={i}>{error.message}</div>
                            ))}
                        </div>
                    )}
                </ModalBody>
            </Modal>
        </>
    );
};

export const RenderScadsysRow = (configuration) => {
    return (
        <>
            <td>Online School ID: {configuration.onlineSchoolID}</td>
            <td>Name: {configuration.institutionName}</td>
        </>
    );
};
